var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"onclick":"history.back()","icon":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("fi fi-rr-arrow-small-left")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }